import { render, staticRenderFns } from "./InPageFooter.vue?vue&type=template&id=4acd277b&scoped=true"
import script from "./InPageFooter.vue?vue&type=script&lang=js"
export * from "./InPageFooter.vue?vue&type=script&lang=js"
import style0 from "./InPageFooter.vue?vue&type=style&index=0&id=4acd277b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acd277b",
  null
  
)

export default component.exports